import React, { useEffect, useState } from "react";

const SessionTimeoutModal = () => {
  // Testing parameters - session expires after 30 seconds, shows warning at 10 seconds remaining
  // const TOTAL_SESSION_TIME = 1800; // 30 minutes = 1800 seconds (total session time)
  const TOTAL_SESSION_TIME = 300; // 5 minute
  const WARNING_TIME = 60; // seconds before expiry to show popup

  const [timeLeft, setTimeLeft] = useState(WARNING_TIME);
  const [showModal, setShowModal] = useState(false);
  const [lastActivity, setLastActivity] = useState(Date.now());

  // Track user activity
  useEffect(() => {
    const activities = [
      "mousedown",
      "mousemove",
      "keypress",
      "scroll",
      "touchstart",
    ];

    const resetTimer = () => {
      setLastActivity(Date.now());
      if (showModal) {
        setShowModal(false);
        setTimeLeft(WARNING_TIME);
      }
    };

    activities.forEach((event) => {
      window.addEventListener(event, resetTimer);
    });

    return () => {
      activities.forEach((event) => {
        window.removeEventListener(event, resetTimer);
      });
    };
  }, [showModal]);

  // Check inactivity and show modal
  useEffect(() => {
    const checkInactivity = () => {
      const now = Date.now();
      const elapsedSeconds = (now - lastActivity) / 1000;
      const secondsUntilWarning = TOTAL_SESSION_TIME - WARNING_TIME;

      if (elapsedSeconds >= secondsUntilWarning) {
        const remainingTime = TOTAL_SESSION_TIME - elapsedSeconds;
        setTimeLeft(Math.max(0, Math.floor(remainingTime)));
        if (!showModal) {
          setShowModal(true);
        }
      }
    };

    // Check every second for precise testing
    const interval = setInterval(checkInactivity, 1000);

    return () => clearInterval(interval);
  }, [lastActivity, showModal]);

  // Countdown when modal is open
  useEffect(() => {
    let timer: NodeJS.Timeout;

    if (showModal) {
      timer = setInterval(() => {
        setTimeLeft((prev) => {
          if (prev <= 1) {
            handleSessionExpire();
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
    }

    return () => {
      if (timer) clearInterval(timer);
    };
  }, [showModal]);

  const handleSessionExpire = () => {
    localStorage.clear();
    window.location.href = "/";
  };

  const handleKeepWorking = () => {
    setLastActivity(Date.now());
    setShowModal(false);
  };

  const formatTime = (seconds: number) => {
    const mins = Math.floor(seconds / 60)
      .toString()
      .padStart(2, "0");
    const secs = (seconds % 60).toString().padStart(2, "0");
    return `${mins}:${secs}`;
  };

  if (!showModal) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
      <div className="bg-white p-6 rounded-lg shadow-lg max-w-md w-full mx-4">
        <div className="text-center">
          <h1 className="text-[#D1A960] font-Poppins font-bold text-[24px] mb-3">
            Session Timout
          </h1>
          <p className="text-[#313131] text-[14px] font-Mulish font-normal">
            Your Session will expire in {formatTime(timeLeft)} Minutes Click
            ‘Keep Working’ if you want to continue and stay logged in.
          </p>
          <button
            onClick={handleKeepWorking}
            className={`w-[98%] sm:w-[30%] mx-auto mt-6 rounded-[8px] bg-primary text-[14px] text-white py-2 sm:px-0 px-4 sm:py-3  transition-colors duration-300 hover:bg-darkgrey disabled:bg-gray-400 disabled:cursor-not-allowed`}
          >
            Keep Working
          </button>
        </div>
      </div>
    </div>
  );
};

export default SessionTimeoutModal;
